import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { useNavigate } from "react-router-dom";

function createData(
  id,
  trackcode,
  reportedodometerreading,
  bookingcode,
  reportedon,
  priority,
  type,
  status
) {
  return {
    id,
    trackcode,
    reportedodometerreading,
    bookingcode,
    reportedon,
    priority,
    type,
    status,
  };
}

const Myissues = ({ selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const issueType = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issueType;
  delete issueType?.inverted;
  const issueStatus = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issueStatus;
  const issuePriority = JSON.parse(
    localStorage.getItem("catalogValues")
  )?.issuePriority;
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [myIssues, setMyIssuesDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [loading, setLoading] = useState(false);
  const [vehicleId, setVehicleId] = useState(null);

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    {
      field: "trackcode",
      headerName: "Track Code",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "reportedodometerreading",
      headerName: "Reported Odometer Reading",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "bookingcode",
      headerName: "Booking Code",
      minWidth: 150,
      align: "start",
    },
    {
      field: "reportedon",
      headerName: "Reported On",
      minWidth: 190,
      align: "start",
    },
    {
      field: "priority",
      headerName: "Priority",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 150,
      align: "start",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      align: "start",
    },
  ];

  const rows =
    (myIssues &&
      myIssues?.map((item) =>
        createData(
          item?.id,
          item?.code,
          item?.reportingOdometerReading + "/ Km",
          item?.bookingCode || "-",
          formatDateAndTime(item?.reportedOn),
          issuePriority[item?.priority],
          issueType[item?.type],
          issueStatus[item?.status]
        )
      )) ||
    [];

  const getVehicleIssues = async (page = 0, pageSize = 20) => {
    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehicleissues?limit=${limit}&offset=${offset}&vehicleId=${vehicleId}`,
        {
          method: "GET",
        }
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setMyIssuesDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }

      return data;
    } catch (error) {
      console.error("Error fetching NRK listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (vehicleId) {
      getVehicleIssues(
        paginationModel.page,
        paginationModel.pageSize
      );
    }
  }, [vehicleId, paginationModel]);

  useEffect(() => {
      if (selectedRow) {
        setVehicleId(selectedRow.id);
      }
    }, [selectedRow]);

  return (
    <>
      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount} // total rows from API
        handleViewClick={(params) => {
          const navigate = `/viewallissues?issueId=${params?.id}&display=true`;
          window.open(navigate, "_blank");
        }}
        api={getVehicleIssues}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
        loading={loading}
        disableColumnMenu={false}
      />
    </>
  );
};

export default Myissues;
